export enum ReportLayout {
  // In the various split modes, toggle will be shown to switch between the split modes
  SplitChartOnly = `split_chart_only`,
  SplitChartTable = `split_chart_table`,
  SplitTableOnly = `split_table_only`,
  // In non-split mode, toggle won't be shown
  NonSplit = `non_split`,
}

export enum ScrollMode {
  PageScroll = `page_scroll`,
  TableScroll = `table_scroll`,
}
